<template>
    <div class="voting-component">
        <div class="voting-buttons">
            <button @click="handleVote('like')" class="btn-vote btn-like" :class="{ active: isLiked }">
                <img src="/images/thumbs-up-solid.png" alt="" class="thumb-icon"> 
                Gefällt mir
                <span v-if="totalLikes > 0" class="like-count">({{ totalLikes }})</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VotingComponent',
    props: {
        goalId: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            isLiked: false,
            totalLikes: 0
        }
    },
    mounted() {
        this.loadLikeState()
        this.loadTotalLikes()
    },
    methods: {
        handleVote(voteType) {
            if (voteType === 'like') {
                this.isLiked = !this.isLiked
                this.saveLikeState()
                this.saveToFile()
                this.$emit('vote', {
                    goalId: this.goalId,
                    voteType: this.isLiked ? 'like' : 'unlike'
                })
            }
        },
        loadLikeState() {
            const likedGoals = JSON.parse(sessionStorage.getItem('likedGoals') || '{}')
            this.isLiked = !!likedGoals[this.goalId]
        },
        saveLikeState() {
            const likedGoals = JSON.parse(sessionStorage.getItem('likedGoals') || '{}')
            if (this.isLiked) {
                likedGoals[this.goalId] = true
            } else {
                delete likedGoals[this.goalId]
            }
            sessionStorage.setItem('likedGoals', JSON.stringify(likedGoals))
        },
        saveToFile() {
            // Send like data to PHP file for counting
            fetch('/server/save-likes.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    goalId: this.goalId,
                    liked: this.isLiked
                })
            }).then(response => response.json())
            .then(data => {
                console.log('Like count updated:', data)
                this.loadTotalLikes() // Refresh total likes after saving
            })
            .catch(err => {
                console.log('Like data saved to session storage only:', err)
            })
        },
        loadTotalLikes() {
            fetch('/server/save-likes.php', {
                method: 'GET'
            })
            .then(response => response.json())
            .then(data => {
                // Find the goal data for this goalId
                const goalNames = {
                    1: 'Politik mit Nähe und Persönlichkeit',
                    2: 'Finanzielle Spielräume gestalten',
                    3: 'Mehr Sicherheit, mehr Miteinander',
                    4: 'Stadtentwicklung mit Zukunft',
                    5: 'Wirtschaft und Handel - unser Motor',
                    6: 'Mobilität, die Bruchköbel bewegt',
                    7: 'Kinder, Jugend & Familie – unsere Zukunft',
                    8: 'Selbstbestimmt und gut umsorgt im Alter',
                    9: 'Kultur leben und erleben',
                    10: 'Bürgernahe Verwaltung – digital und persönlich'
                }
                
                const goalName = goalNames[this.goalId]
                const goalData = data.find(item => item.goal === goalName)
                
                if (goalData) {
                    this.totalLikes = goalData.likes || 0
                }
            })
            .catch(err => {
                console.log('Could not load total likes:', err)
                this.totalLikes = 0
            })
        }
    }
}
</script>


